/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareLetterC = createReactComponent("square-letter-c", "IconSquareLetterC", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", key: "svg-1" }]
]);

export { IconSquareLetterC as default };
//# sourceMappingURL=IconSquareLetterC.js.map
